
export interface ILoginHistory {
    Id: number;
    UserId: number;
    CreatedTime: Date;
    IP: string;
    Client: string;
    Source: LoginSource;
}

export enum LoginSource {
    Silverlight,
    Unknown,
    Valkyrie,
    DriverPanel
}

export class LoginHistoryService {

    static $inject = ["$http"];

    constructor(
        private readonly $http: angular.IHttpService) {
    }

    getLatestLoginHistories(): angular.IPromise<ILoginHistory[]> {
        return this
            .$http({
                method: "GET",
                url: `/api/loginhistory/`,
                cache: true
            })
            .then((result: angular.IHttpPromiseCallbackArg<ILoginHistory[]>) => {
                return result.data;
            });
    }

    getLatestLoginHistoryForUser(userId : number): angular.IPromise<ILoginHistory> {
        return this
            .$http({
                method: "GET",
                url: `/api/loginhistory/${userId}`,
                cache: true
            })
            .then((result: angular.IHttpPromiseCallbackArg<ILoginHistory>) => {
                return result.data;
            });
    }


    getAllLoginHistoryForUser(userId: number, startTime: moment.Moment, endTime: moment.Moment): angular.IPromise<ILoginHistory[]> {
        return this
            .$http({
                method: "GET",
                url: `/api/loginhistory/${userId}/all`,
                cache: true,
                params: {
                    startTime: startTime.toISOString(),
                    endTime: endTime.toISOString()
                }
            })
            .then((result: angular.IHttpPromiseCallbackArg<ILoginHistory[]>) => {
                return result.data;
            });
    }
}
